import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { todayDateRange } from "../../../../../utils/date_formatter";

export interface IPaginationState {
  page: number;
  lastVisitedPage: number;
  paginatedData: Record<
    number,
    {
      data: any;
      filters: Record<string, string | number>;
    }
  >;
  filters: Record<string, string | number>;
}

const initialState: IPaginationState = {
  page: 1,
  lastVisitedPage: 1,
  paginatedData: {},
  filters: {
    period: "today",
    start_date: todayDateRange()[0],
    end_date: todayDateRange()[1],
    branch: "",
  },
};

const PaginationSlice = createSlice({
  name: "expensesVisualizationPagination",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPaginatedData: (
      state,
      action: PayloadAction<{ page: number; data: any }>,
    ) => {
      const { page, data }: { page: number; data: any } = action.payload;
      state.paginatedData[page] = {
        data,
        filters: state.filters,
      };
    },
    setLastVisitedPage: (state, action: PayloadAction<number>) => {
      state.lastVisitedPage = action.payload;
    },
    clearPaginatedData: (state) => {
      state.paginatedData = {};
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
  },
});

export const {
  setPage,
  setPaginatedData,
  setLastVisitedPage,
  clearPaginatedData,
  setFilters,
} = PaginationSlice.actions;

export const selectPagination = (state: {
  expensesVisualizationPagination: IPaginationState;
}) => state.expensesVisualizationPagination;

export default PaginationSlice.reducer;
